/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AddressDtoFromJSON(json) {
    return AddressDtoFromJSONTyped(json, false);
}
export function AddressDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'addressId': !exists(json, 'addressId') ? undefined : json['addressId'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'streetWithLocal': !exists(json, 'streetWithLocal') ? undefined : json['streetWithLocal'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'buildingNumber': !exists(json, 'buildingNumber') ? undefined : json['buildingNumber'],
        'apartmentNumber': !exists(json, 'apartmentNumber') ? undefined : json['apartmentNumber'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
    };
}
export function AddressDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'addressId': value.addressId,
        'city': value.city,
        'street': value.street,
        'buildingNumber': value.buildingNumber,
        'apartmentNumber': value.apartmentNumber,
        'postalCode': value.postalCode,
    };
}
